// @ts-nocheck
import Logger from "@sf-intl/reporter-sdk";
import { initConfig } from "./static";
// console.log("神策埋点-process.env.NODE_ENV", process.env.NODE_ENV);

interface Event {
  sceneType: string; //页面
  eventType: string; //事件名称
  resultType?: string; //错误码
  message?: string; //额外消息
  testType?: string; //测试类型
}

interface EventProperty {
  sceneType: string; //事件名称
  resultType: string; //错误码
  message: string; //额外消息
  testType: string; //测试类型
}

Logger.init(initConfig);

Logger.registerPage({
  // 设置事件静/动态公共属性，需在 SDK 初始化之后调用
  platform_env: location.hostname.includes("sit") ? "sit" : "prd", //"prd/dev/sit/test"
  system_code: "AMIS-OS-CLAIM",
  platform_type: "Web",
  platform_name: "AMIS-理赔",
  product_code: "AMIS-OS-CLAIM",
  intl_workCode: "",
});

export const $logger = Logger;

/**
 *
 * @param {string} eventType //页面
 * @param {string} sceneType //事件名称
 * @param {string} resultType //错误码
 * @param {string} message //额外消息
 * @param {string} testType //测试类型
 * @param {string} consumeTime //交互过程中的耗时
 * @param {string} sessionId //环信会话id
 * @returns {any}
 */
export const $track = (event: Event) => {
  const properties = {};
  if (event.sceneType) properties.intl_sceneType = event.sceneType;
  if (event.eventType) properties.intl_eventType = event.eventType;
  if (event.resultType) properties.intl_resultType = event.resultType;
  if (event.testType) properties.intl_testType = event.testType;
  if (event.message) properties.intl_message = event.message;
  if (event.consumeTime) properties.intl_consume_time = event.consumeTime;
  if (event.sessionId) properties.intl_session_id = event.sessionId;
  Logger.track(`intl_trigger`, properties);
};

/**
 *
 * @param {string} eventType //页面
 * @param {string} sceneType //事件名称
 * @param {string} resultType //错误码
 * @param {string} message //额外消息
 * @param {string} testType //测试类型
 * @returns {any}
 */
export const $view = (event: Event) => {
  const properties = {};
  if (event.sceneType) properties.intl_sceneType = event.sceneType;
  if (event.eventType) properties.intl_eventType = event.eventType;
  if (event.resultType) properties.intl_resultType = event.resultType;
  if (event.testType) properties.intl_testType = event.testType;
  if (event.message) properties.intl_message = event.message;
  if (event.consumeTime) properties.intl_consume_time = event.consumeTime;
  if (event.sessionId) properties.intl_session_id = event.sessionId;
  Logger.track(`intl_page_view`, properties);
};

export const $setProfile = (data) => Logger.setProfile(data); // 直接设置用户的属性，如果存在则覆盖

export const $setProperties = (data) => Logger.registerPage(data); // 更新覆盖公共属性的值
